import script from "./Paying.vue?vue&type=script&setup=true&lang=js"
export * from "./Paying.vue?vue&type=script&setup=true&lang=js"

import "./Paying.vue?vue&type=style&index=0&id=556ff28b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-556ff28b"]])

export default __exports__